import {
  ErrorMessage,
  RadioButton,
  Spinner,
  Button,
  SuccessPopup,
  InfoBox,
} from "@/common/components";
import { useContext, useEffect, useState } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  useGetProductRulesQuery,
  useSaveProductRulesMutation,
} from "@/service/ProductService";
import { scrollToTop } from "@/utils/Utilities";

const ProductRules = () => {
  const {
    setNavHeader,
    cancel,
    labels,
    setPageHeader,
    accessorPrivileges,
    location,
    isRiccAdministrator,
  } = useContext(PrivateContext);

  const [processRules, setProcessRules] = useState([]);
  const [selectedRules, setSelectedRules] = useState([]);
  const [showPopup, setShowPopup] = useState("");
  const [isRadioButtonPresent, setIsRadioButtonPresent] = useState(true);

  const {
    data: productRules,
    isFetching,
    error,
  } = useGetProductRulesQuery({
    productSponsorId: location?.state?.productSponsorId,
    productId: location?.state?.productId,
  });

  const [
    saveOrUpdateProductRulesApi,
    { isLoading: isFetching1, error: error1 },
  ] = useSaveProductRulesMutation();

  const addNewRules = () => {
    setSelectedRules(processRules.map(() => "1"));
  };

  const updateRules = () => {
    scrollToTop();
    const scripts = [];
    processRules.forEach((e, index) => {
      if (selectedRules[index] && selectedRules[index].slice(-1) != "0") {
        scripts.push({
          codeName: e.data[0].codeName,
          scriptId: selectedRules[index].replace(/\D/g, ""),
        });
      }
    });

    let payload = {
      productMfgId: location?.state?.productSponsorId,
      productId: location?.state?.productId,
      productProcessRuleScripts: scripts,
    };

    saveOrUpdateProductRulesApi(payload)
      .unwrap()
      .then((res) => {
        if (!res.inError) {
          setShowPopup(true);
        }
      });
  };

  const checkDisabled = () => {
    if (
      !isRiccAdministrator &&
      (accessorPrivileges["PROCESS RULE"] !== "ADD" ||
        accessorPrivileges["PROCESS RULE" !== "UPDATE"])
    ) {
      return true;
    }

    if (selectedRules.length < 1) {
      return false;
    }

    if (isRadioButtonPresent) {
      return selectedRules.every(
        (item) => item === "" || item === "0" || item === 0
      );
    }
  };

  useEffect(() => {
    if (productRules && productRules?.processRules) {
      setProcessRules(
        productRules?.processRules?.map((e) => {
          return {
            header: e.displayName,
            data: e?.processRuleScripts?.map((e1) => {
              return {
                id: e1.codeName + e1.scriptId,
                name: e1.codeName + e1.scriptId,
                codeName: e1.codeName,
                label: e1.displayName,
                description: e1.description,
                productProcessRuleScripts: e1.productProcessRuleScripts,
              };
            }),
            processRuleScripts: e?.processRuleScripts?.length,
          };
        })
      );
    }
  }, [productRules]);

  useEffect(() => {
    let rules = [];
    if (processRules && processRules?.length) {
      processRules.forEach((e) => {
        if (e.processRuleScripts >= 1) {
          e.data?.forEach((e1) => {
            if (e1.productProcessRuleScripts.length) {
              rules.push(e1.id);
            }
          });
        } else {
          rules.push("");
        }
      });
    }
    if (!rules.every((item) => item === "")) setSelectedRules(rules);
    setIsRadioButtonPresent(
      processRules.find((e) => e.data?.length > 1) ?? false
    );
  }, [processRules]);

  useEffect(() => {
    setPageHeader(labels?.productRules?.title + location?.state?.name);
    setNavHeader(labels?.navbar?.product);
  }, []);

  return (
    <section className="container-large productRules py-5">
      {(isFetching || isFetching1) && <Spinner />}
      <ErrorMessage error={error || error1} wrapperClassName="mb-3" />
      {processRules && selectedRules.length ? (
        <>
          {processRules.map((e, index) => {
            return e.data.length > 1 ? (
              <RadioButton
                key={e.header}
                wrapperClassName="mb-4"
                data={e}
                value={selectedRules[index]}
                selected={(e1) => {
                  selectedRules[index] = e1;
                  setSelectedRules([...selectedRules]);
                }}
              />
            ) : (
              <div className="mb-4" key={e.header}>
                <div className="mb-2 fw-bold">{e?.header}</div>
                <label className="fw-normal mb-2">{e.data[0].label}</label>
                <div className="small mb-2">{e.data[0].description}</div>
              </div>
            );
          })}
        </>
      ) : (
        <>
          <InfoBox message={labels?.productRules?.notEstablished} />
        </>
      )}

      <div className="d-flex justify-content-center mt-5">
        <Button
          id="cancel"
          text={labels?.productRules?.cancel}
          type="secondary"
          wrapperClassName="col-md-2 me-1 col-6"
          click={cancel}
        />

        <Button
          id="Done"
          text={
            selectedRules.length
              ? labels?.productRules?.done
              : labels?.productRules?.addProductRules
          }
          wrapperClassName={`col-6 ${
            selectedRules.length ? "col-md-2" : "col-md-3"
          }`}
          click={selectedRules.length ? updateRules : addNewRules}
          disabled={checkDisabled()}
        />
      </div>

      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.productRules?.continue}
        click={cancel}
        body={labels?.productRules?.requestCompleted}
      />
    </section>
  );
};

export default ProductRules;
